import styled from "@emotion/styled";

export const StyledPrivacyPolicy = styled.div`
  .privacy-container {
    background: var(--bg-alt);
    padding: 20px;
    display: flex;
    justify-content: center;
  }

  .privacy-card {
    max-width: 900px;
    width: 100%;
    border-radius: 12px;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.05);
  }

  .privacy-title {
    color: var(--text);
  }
  .last-updated {
    color: var(--text-light);
  }
  .privacy-section {
    margin-bottom: 32px;
  }

  .privacy-section h4 {
    color: var(--primary);
    margin-bottom: 12px;
  }

  .ant-list-item {
    padding: 4px 0;
    border: none;
    color: var(--text);
  }

  .ant-typography {
    color: var(--text);
  }
`;
